import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import classnames from 'classnames'
import { useTranslation } from 'react-i18next'

import {
  getBlockUnratedUrls,
  getExcludeUnrateable,
  getFormattedCustomSegmentIds,
  getFormattedSafetyOptions
} from '../helpers'

import { dv360TargetingSelector } from '../../../../../../../modules/selectors/dv360Constants'

import {
  safetyEnumsOptions,
  safetyOptions
} from '../../../../../UploadDV360AdCreative/UploadDV360AdCreativeForm/LineItemForm/fields'

import useDrawerFormStyles from '../../../../../../../styles/common/drawerForms'
import useStyles from './styles'

const ThirdPartyVerificationSectionPreview = () => {
  const { t } = useTranslation()

  const drawerFormClasses = useDrawerFormStyles()
  const classes = useStyles()

  const targeting = useSelector(dv360TargetingSelector)

  const formattedSafetyOptions = useMemo(() => {
    return getFormattedSafetyOptions(targeting)
  }, [targeting])

  const excludeUnrateable = useMemo(() => {
    return getExcludeUnrateable(targeting)
  }, [targeting])

  const formattedCustomSegmentIds = useMemo(() => getFormattedCustomSegmentIds(targeting), [targeting])

  const blockUnratedUrls = useMemo(() => getBlockUnratedUrls(targeting), [targeting])

  return (
    <>
      <section className={classnames(drawerFormClasses.section, classes.safetyOptionsSection)}>
        {safetyOptions.map(option => {
          const safetyOptionLabel = safetyEnumsOptions.find(
            safetyOption => safetyOption.value === formattedSafetyOptions[option.value]
          )?.label
          return (
            <p className={classes.safetyOptionPreviewItem}>
              <span>{option.label}: </span>
              <span>{safetyOptionLabel}</span>
            </p>
          )
        })}
        <p className={classes.safetyOptionPreviewItem}>
          <span>{t('Exclude Unrateable')}</span>
          <span>{excludeUnrateable ? 'Yes' : 'No'}</span>
        </p>
      </section>
      <section className={classnames(drawerFormClasses.section, classes.safetyOptionsSection)}>
        <h3 className={drawerFormClasses.sectionTitle}>{t('Custom segments IDs')}</h3>
        {formattedCustomSegmentIds.map((customSegmentId, index) => {
          return <p key={index}>{customSegmentId.text}</p>
        })}
        <div className={classes.blockUnratedUrlsWrapper}>
          <h3 className={classnames(drawerFormClasses.sectionTitle, classes.blockUnratedUrlsTitle)}>
            {t('Block Unratead URLs')}
          </h3>
          <span>{blockUnratedUrls ? 'Yes' : 'No'}</span>
        </div>
      </section>
    </>
  )
}

export default ThirdPartyVerificationSectionPreview
